// extracted by mini-css-extract-plugin
export var embeddedImg = "styles-module--embeddedImg--+wWio";
export var integratedCare = "styles-module--integratedCare--J6tQ3";
export var textContainer = "styles-module--textContainer--M8X0N";